import { Controller } from '@hotwired/stimulus'

// The slide follows the bar order, not history: Turbo marks every tab tap as forward.
export default class extends Controller {
  connect() {
    this.serverActive = this.element.querySelector('.is-active[data-nav-index]')

    this.onLoad = () => this.clear()
    this.onStay = () => this.restore()

    document.addEventListener('turbo:load', this.onLoad)
    // a stream answers in place, a failed fetch not at all: neither confirms the tap
    document.addEventListener('turbo:before-stream-render', this.onStay)
    document.addEventListener('turbo:fetch-request-error', this.onStay)
  }

  // Clearing the direction here would drop it mid view transition, before it is ever read.
  disconnect() {
    document.removeEventListener('turbo:load', this.onLoad)
    document.removeEventListener('turbo:before-stream-render', this.onStay)
    document.removeEventListener('turbo:fetch-request-error', this.onStay)
  }

  pick(event) {
    const target = event.target.closest('[data-nav-index]')
    const current = this.element.querySelector('.is-active[data-nav-index]')

    if (!target) return

    // tapping the tab of the screen already on screen is a no-op, like a native tab bar
    if (target.pathname === window.location.pathname) {
      event.preventDefault()
      return
    }

    if (!current) return

    const from = Number(current.dataset.navIndex)
    const to = Number(target.dataset.navIndex)

    if (from === to) return

    document.documentElement.dataset.maDirection =
      to > from ? 'forward' : 'back'
    this.activate(target)
  }

  // lights the tab up on tap like a native tab bar; the server render still decides
  activate(target) {
    this.items.forEach((tab) => {
      tab.classList.toggle('is-active', tab === target)
    })
  }

  restore() {
    if (this.serverActive) this.activate(this.serverActive)
  }

  clear() {
    delete document.documentElement.dataset.maDirection
  }

  get items() {
    return this.element.querySelectorAll('[data-nav-index]')
  }
}
